import { Promo, TPromoMaxWidth } from '@hg/stylizator/components'
import { Background as TBackground } from '@hg/stylizator/utils'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export interface IAttributes
  extends Omit<
    React.ComponentProps<typeof Promo>,
    'linkText' | 'linkUrl' | 'linkToExternal' | 'linkClassName' | 'background' | 'maxWidth'
  > {
  linkText: string
  linkUrl: string
  background: TBackground
  maxWidth: TPromoMaxWidth
  linkToExternal: boolean
  linkClassName: string
}

const PromoBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  const { subtitle } = attributes

  return (
    <Promo
      title={attributes.title}
      background={attributes?.background ?? 'white'}
      subtitle={typeof subtitle === 'string' ? parse(subtitle) : subtitle}
      linkText={attributes.linkText ?? ''}
      linkUrl={attributes.linkUrl ?? ''}
      maxWidth={attributes.maxWidth ?? 'contain'}
      linkToExternal={attributes.linkToExternal ?? false}
      linkClassName={attributes.linkClassName ?? ''}
    />
  )
}

export default PromoBlock
